import { useEffect, useMemo, useState } from 'react';
import api from './api';
import { ambientMood, PULSE_REFRESH_MS } from './ambient';

// Polls the portfolio pulse every five minutes while the page is visible
// (and at once when it becomes visible again); null until the first answer.
export const useAmbient = (enabled = true) => {
  const [pulse, setPulse] = useState(null);
  useEffect(() => {
    if (!enabled) return undefined;
    let alive = true;
    const load = () => {
      if (document.visibilityState === 'hidden') return;
      Promise.resolve(api.get('/portfolio/pulse'))
        .then((res) => { if (alive && res?.data) setPulse(res.data); })
        .catch(() => {});
    };
    load();
    const id = setInterval(load, PULSE_REFRESH_MS);
    const onVisible = () => { if (document.visibilityState === 'visible') load(); };
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      alive = false;
      clearInterval(id);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, [enabled]);
  return useMemo(() => (pulse ? ambientMood(pulse) : null), [pulse]);
};
